import { render, staticRenderFns } from "./formCustom.vue?vue&type=template&id=90ea8560&scoped=true&"
import script from "./formCustom.vue?vue&type=script&lang=ts&"
export * from "./formCustom.vue?vue&type=script&lang=ts&"
import style0 from "./formCustom.vue?vue&type=style&index=0&id=90ea8560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ea8560",
  null
  
)

export default component.exports